export default __webpack_public_path__ + "static/media/36.b70e1faa.png";